import { MemberElectionsPageContent } from "./_components/MemberElectionsPageContent";

export default function PastMemberElectionsPage() {
  return <MemberElectionsPageContent activeTab="past" />;
}
